<template>
  <div class="ml-3 mb-2 mr-3">
    <div class="ml-2 mb-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Documentos</strong>
    </div>
    <div v-if="!!documents.length">
      <custom-callout
        v-for="(item, idx) in documents"
        id="customCalloutUploadDownloadDocumentsPdf"
        :key="idx"
        border-color-hex="#E2E2E2"
        class="ml-2 mt-3 mb-2"
        :has-toggle="false"
      >
        <div class="ml-md-3 mr-md-3 mt-md-1 mb-md-1">
          <div class="row d-flex align-items-center">
            <div class="col-md-3 col-sm-12">
              <span class="data-title d-block border-mobile">
                Tipo de Documento:
              </span>
              <span class="font-16 color-black">
                <span>{{ getContractDocumentName(item) }}</span>
              </span>
            </div>
            <div class="col-md-3 col-sm-12">
              <span class="data-title d-block border-mobile">
                Fecha:
              </span>
              <span class="font-16 color-black">
                <span>{{ item.lastModifyDate | datetime }}</span>
              </span>
            </div>
            <div v-if="item.documentFilename" class="col-md-3 col-sm-12">
              <span class="data-title d-block border-mobile ml-md-5 align-file">
                Archivo:
              </span>
              <span class="font-16 color-black ml-md-5 align-file">
                {{ item.documentFilename }}
              </span>
            </div>
            <div v-if="!item.documentFilename" class="col-md-3 col-sm-12" />
            <div
              v-if="item.documentFilename || item.documentAttachmentId"
              class="
                col-md-3 col-sm-12
                d-flex
                justify-content-end
                align-items-start
              "
            >
              <action-button
                id="actionBtnDownloadDocumentsPdf"
                i="fas fa-file-download"
                variant="success pr-1"
                @click="onDownloadHandler(item)"
              />
              <action-button
                v-if="canReplaceDocument && isUpdatableDocument(item)"
                id="actionBtnUpdateDocumentsPdf"
                i="fas fa-undo"
                variant="outline-success ml-2 pr-1"
                @click="addDoc(item)"
              />
              <custom-file-input
                v-if="canReplaceDocument && isUpdatableDocument(item)"
                id="customInptUpdateDocumentsPdf"
                ref="documentInputRef"
                :accept="allowedFiles"
                class="file-input__extended"
                display-style="normal"
                name=" "
                :on-download="onDownloadFile"
                required
                style="display: none"
                :value="item.file"
                @input="(file) => onUploadFileHandler(file, item)"
              />
            </div>
            <div
              v-if="
                !item.documentFilename &&
                  canUploadDocument &&
                  isUpdatableDocument(item)
              "
              class="
                col-md-3 col-sm-12
                d-flex
                justify-content-end
                align-items-start
              "
            >
              <action-button
                id="actionBtnUploadDocumentsPdf"
                i="fas fa-file-medical"
                variant="success pr-1"
                @click="addDoc(item)"
              />
              <custom-file-input
                id="customInptFileUploadDocumentsPdf"
                ref="documentInputRef"
                :accept="allowedFiles"
                class="file-input__extended"
                display-style="normal"
                name=" "
                :on-download="onDownloadFile"
                required
                style="display: none"
                :value="item.file"
                @input="(file) => onUploadFileHandler(file, item)"
              />
            </div>
          </div>
        </div>
      </custom-callout>
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        save-text="Aceptar"
        show-cancel
        show-save
        title="Certificación"
        :value="showModal"
        width="750px"
        @cancel="onCancelAcceptTermHandler"
        @save="onAcceptTermHandler"
      >
        <custom-checkbox-single-option
          id="customCheckboxShowCertification"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          title="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
        />
      </custom-modal>
      <pagination
        v-if="pagination.totalItemCount > 5"
        :data="pagination"
        show-text
        @page-size-change="changePageSize"
        @pagination-go-page="goToPageHandler"
      />
    </div>
    <div v-else class="pb-5">
      <custom-result-not-found text="No cuenta con Documentos." />
    </div>
  </div>
</template>

<script>
import objectToFormData from 'object-to-formdata';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import {
  getDocuments,
  addDocument,
} from '@/services/provider/billing-document.api';
import Pagination from 'pagination';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import CustomResultNotFound from 'custom-result-not-found';
import CustomFileInput from 'CustomFileInput';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { getContractDocumentMask as _getContractDocumentMask } from '@/utils/constants/contractDocumentTypes';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import { downloadDocumentByHex as _downloadDocumentByHex } from '@/services/common/documentHex';
import billingStatus from '@/utils/constants/billingStatus';
import { contractDocumentTypes } from '@/utils/constants/contractDocumentTypes.js';

export default {
  name: 'Documents',
  mixins: [alertMixin],
  components: {
    ActionButton,
    CustomCallout,
    CustomModal,
    Pagination,
    CustomFileInput,
    CustomResultNotFound,
    CustomCheckboxSingleOption,
  },
  async mounted() {
    await this.getDataFromApi();
  },
  props: {
    contract: {
      type: Object,
      default: null,
    },
    billModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      documents: [],
      selectedItem: {},
      acceptedTerms: false,
      showUploadTest: false,
      allowedFiles: '.pdf',
      pagination: {
        pageIndex: 1,
        pageSize: 5,
        totalItemCount: 0,
        showPageSizeOptions: false,
        pageSizeOptions: [5, 10, 25, 30],
      },
    };
  },
  computed: {
    canUploadDocument() {
      return !this.isReadOnlyMode;
    },
    canReplaceDocument() {
      return !this.isReadOnlyMode;
    },
    isReadOnlyMode() {
      return this.billModel?.statusId !== billingStatus.Preliminar;
    },
    isUpdatableDocument() {
      return ({ contractDocumentTypeId }) =>
        contractDocumentTypeId === contractDocumentTypes.otros;
    },
  },
  methods: {
    async getDataFromApi() {
      let payload = {
        contractId: this.contract.contractId,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      };
      const { data } = await getDocuments(payload);
      this.documents = data.data;
      this.pagination = {
        ...this.pagination,
        count: data.count,
        currentPage: data.currentPage,
        pageCount: data.pageCount,
        totalItemCount: data.totalItemCount,
      };
    },
    async onCancelAcceptTermHandler() {
      var inputIndex = this.documents.findIndex((x) => x === this.selectedItem);
      if (inputIndex > -1) {
        this.$refs.documentInputRef[inputIndex].removeFile();
      }
      this.showModal = false;
      this.acceptedTerms = false;
    },
    async changePageSize(size) {
      this.pagination.pageSize = size;
      await this.getDataFromApi();
    },
    async goToPageHandler(page) {
      this.pagination.pageIndex = page;
      await this.getDataFromApi();
    },
    async onDownloadFile() {
      return new Promise();
    },
    async onUploadFileHandler(file, item) {
      if (!file) return;
      item = this.selectedItem;
      item.documentFilename = file?.name;
      item.file = file;
      item.contractDocumentDate = file?.lastModifiedDate;

      let dataToSend = objectToFormData(
        {
          id: item.id,
          documentAttachmentId: null,
          visitSummaryId: null,
          documentTypeId: item.documentTypeId,
          contractDocumentTypeId: item.contractDocumentTypeId,
          documentTypeName: item.documentTypeName,
          documentFilename: item.documentFilename,
          contractDocumentDate: item.contractDocumentDate,
          academicYearId: item.academicYearId,
          disciplineTypeId: this.contract.disciplineId,
          subDisciplineTypeId: null,
          specialistId: this.contract.specialistId,
          companyId: null,
          contractId: item.contractId,
          contractDocumentStatusId: null,
          requestId: null,
          authenticityCertificationCheck: item.authenticityCertificationCheck,
          isAmendment: item.isAmendment,
          file: file,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      let { data } = await addDocument(dataToSend);
      item.documentAttachmentId = data;
    },
    addDoc(item) {
      this.showModal = true;
      this.selectedItem = item;
    },

    async onAcceptTermHandler() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor certifique el documento  que ha subido al sistema REMpro.',
          'error'
        );
        return;
      }
      this.acceptedTerms = false;
      this.showModal = false;
      const otherDocumentTypeIndex = 0;
      await this.$refs.documentInputRef[otherDocumentTypeIndex].removeFile();
      this.$refs.documentInputRef[
        otherDocumentTypeIndex
      ].$refs.fileuploadRef.click();
    },

    onDownloadHandler(item) {
      if (item.content && !item.documentAttachmentId) {
        _downloadDocumentByHex(item.documentFilename, item.content);
        return;
      }
      _downloadDocumentByAttachmentId(item.documentAttachmentId).catch(
        (err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        }
      );
    },

    getContractDocumentName(item) {
      return _getContractDocumentMask(
        item.contractDocumentTypeId,
        item.isAmendment
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: #ff7058;
}
.align-file {
  padding-left: 83px;
}
</style>
